import * as React from "react";
import styled from "@mui/material/styles/styled";
import { ProfileHeader } from "./profileHeader";
import { ProfileSection } from "./profileSection";
import { KahunCategories } from "shared";

//region [[ Styles ]]

const ProfileContainerView = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  color: "black",
  padding: "20px",
}));

export enum ProfileSectionType {
  BasicInformation = "Basic Information",
  PersonalInformation = "Personal Information",
  Medications = "Medications",
  Allergies = "Allergies",
  HealthBackground = "Health Background",
}

//endregion [[ Styles ]]

//region [[ Props ]]

export interface ProfileContainerProps {}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const ProfileContainer = ({ ...props }: ProfileContainerProps) => {
  return (
    <ProfileContainerView>
      <ProfileHeader>Profile Header</ProfileHeader>

      <ProfileSection
        section={ProfileSectionType.PersonalInformation}
        question={"Want to tell us about your chronic diseases?"}
        addText={"Add More Disease"}
        categories={[
          KahunCategories.SIGNS_SYMPTOMS,
          KahunCategories.KAHUN_SYMPTOMS,
          KahunCategories.SIGN,
        ]}
      ></ProfileSection>
      <ProfileSection
        section={ProfileSectionType.Medications}
        question={"Are you taking any medicine?"}
        addText={"Add More Medicine"}
        categories={[KahunCategories.MEDICINE]}
      ></ProfileSection>
      <ProfileSection
        section={ProfileSectionType.Allergies}
        question={"Do you have any allergies?"}
        addText={"Add More Allergy"}
        categories={[KahunCategories.ALLERGIES]}
      ></ProfileSection>
      <ProfileSection
        section={ProfileSectionType.HealthBackground}
        question={"Do you have a family history of chronic diseases?"}
        addText={"Add More Family History"}
        categories={[
          KahunCategories.SIGNS_SYMPTOMS,
          KahunCategories.KAHUN_SYMPTOMS,
          KahunCategories.SIGN,
        ]}
      ></ProfileSection>
    </ProfileContainerView>
  );
};
